import localizationDefinitions from '~~/i18n/localizationDefinitions';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export const hasNativeRouteRedirection = (countryCode: CountryCodeValue) => {

  return localizationDefinitions.getByCountryCode(countryCode)?.hasNativeRouteRedirection() || false;

};
